import { ethers } from "ethers";
import marketplaceAbi from "../abis/NFTMarketplace.json";

const MARKETPLACE_ADDRESS = "0x0cCC053bA17A822e073A8F4c057a23922ee0B161";

export function getMarketplaceContract(signerOrProvider) {
  return new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, signerOrProvider);
}
